import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockKeyholeIcon, EyeOffIcon, UsersIcon } from 'lucide-react';
const trustSignals = [{
  icon: LockKeyholeIcon,
  title: 'Secure Data',
  description: 'Your expense data is encrypted and stored securely.'
}, {
  icon: EyeOffIcon,
  title: 'Private by Design',
  description: 'We do not sell your data to third parties. Your group expenses stay private.'
}, {
  icon: UsersIcon,
  title: 'You are in control',
  description: 'You decide who sees your kitties and who you share expenses with.'
}, {
  icon: ShieldCheckIcon,
  title: 'No real money held',
  description: 'KittyPot tracks expenses. We never touch, hold, or move your real money.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: 'easeOut'
    }
  }
};
export function TrustSecurity() {
  return <section className="py-24 lg:py-32 bg-gray-950 text-white relative overflow-hidden" data-id="element-230">
      {/* Subtle glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-231">
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[400px] bg-kitty-yellow/[0.04] rounded-full blur-3xl" data-id="element-232" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16 lg:mb-20" data-id="element-234">
          <div className="inline-flex items-center gap-2 bg-white/[0.06] border border-white/[0.1] rounded-full px-4 py-1.5 mb-6" data-id="element-235">
            <ShieldCheckIcon className="w-4 h-4 text-kitty-yellow" data-id="element-236" />
            <span className="text-sm font-medium text-gray-300" data-id="element-237">
              Security & Trust
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight mb-5" data-id="element-238">
            Your data is safe.{' '}
            <span className="text-kitty-yellow" data-id="element-239">Always.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-md mx-auto leading-relaxed" data-id="element-240">
            Built with privacy and security in mind.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-id="element-241">
          {trustSignals.map(item => <motion.div key={item.title} variants={itemVariants} className="rounded-2xl bg-white/[0.04] border border-white/[0.08] p-6 lg:p-8 text-center flex flex-col items-center" data-id="element-242">
              <div className="w-12 h-12 rounded-2xl bg-kitty-yellow/10 flex items-center justify-center mb-5" data-id="element-243">
                <item.icon className="w-6 h-6 text-kitty-yellow" data-id="element-244" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-245">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" data-id="element-246">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}